/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindCertificateRequestsByCertificateIdQueryResponse,
  FindCertificateRequestsByCertificateIdQueryParams,
} from "../types/FindCertificateRequestsByCertificateId.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCertificateRequestsByCertificateIdQueryKey = (
  params: FindCertificateRequestsByCertificateIdQueryParams
) =>
  [
    {
      url: "/v1/certificate-request/find-certificate-requests-by-certificate-id",
    },
    ...(params ? [params] : []),
  ] as const

export type FindCertificateRequestsByCertificateIdQueryKey = ReturnType<
  typeof findCertificateRequestsByCertificateIdQueryKey
>

/**
 * @summary Find certificate requests by certificate id
 * {@link /v1/certificate-request/find-certificate-requests-by-certificate-id}
 */
export async function findCertificateRequestsByCertificateId(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificateRequestsByCertificateIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate-request/find-certificate-requests-by-certificate-id`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCertificateRequestsByCertificateIdQueryOptions(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCertificateRequestsByCertificateIdQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findCertificateRequestsByCertificateId(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find certificate requests by certificate id
 * {@link /v1/certificate-request/find-certificate-requests-by-certificate-id}
 */
export function useFindCertificateRequestsByCertificateId<
  TData = ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
  TQueryData =
    ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
  TQueryKey extends QueryKey = FindCertificateRequestsByCertificateIdQueryKey,
>(
  params: FindCertificateRequestsByCertificateIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificateRequestsByCertificateIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findCertificateRequestsByCertificateIdQueryKey(params)

  const query = useQuery(
    {
      ...findCertificateRequestsByCertificateIdQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
